module.exports = __webpack_public_path__ + "img/microsoftstore.fe503441.png";